<attributes-editor
  #attributesEditor
  [dataSource]="editorDataSource"
  fxFlexWidth="100%"
  [useAttributeDescription]="true"
  [isPrivate]="survey?.form?.isPrivate"
  (downloadFile)="downloadFile($event)"
  (blurred)="onAttributeBlurred()"
>
</attributes-editor>
<validation-summary
  [failedValidations]="formFailedValidations"
  label="survey"
></validation-summary>
<button
  mat-flat-button
  class="large mb-1"
  [disabled]="isSaving"
  appThrottleClick
  (throttledClick)="saveSurvey()"
>
  Submit Survey
</button>
